import { inject, Injectable } from '@angular/core';
import { LoggerService } from '../../services/logger/logger-service/logger.service';
import { LogLevel } from '@azure/msal-browser';

/**
 * Adapter for connecting the MSAL log callback to the logger service.
 */
@Injectable({
  providedIn: 'root',
})
export class MsalLoggerBridgeService {
  logger = inject(LoggerService);

  /**
   * MSAL logger callback
   */
  callback = (
    logLevel: LogLevel,
    message: string,
    containsPii: boolean,
  ): void => {
    // Never log Personally Identifiable Information.
    if (containsPii) {
      return;
    }

    switch (logLevel) {
      case LogLevel.Error:
        this.logger.error(message);
        break;

      case LogLevel.Warning:
        this.logger.warn(message);
        break;

      case LogLevel.Info:
        this.logger.info(message);
        break;

      case LogLevel.Verbose:
        this.logger.debug(message);
        break;
    }
  };
}
